import dialogConstant from 'BASE/common/dialogConstant';

export const dialogComponent = {
    props: {
        name: String,
        backdropClose: Boolean,
        disableMask: Boolean
    },
    data() {
        return {
            isOpen: false,
            data: {},
            options: {},
            countdown: -1,
            
            defOptions: {
                title: '温馨提示',
                cancelStr: '取消',
                confirmStr: '确定',
                autoHideLength: -1,
                warningAutoHideLength: 3,    //共用warning視窗預設倒數秒數
                onClose: null    // 新增：關閉時執行的回調函數
            }
        }
    },
    methods: {
        show(data, options) {
            // options
            this.options = Object.assign({}, this.defOptions, options);

            // data
            this.data = data;

            // scrollbar handle
            document.body.classList.add('v-dialog-show');
            document.body.style.paddingRight = dialogPlugin.scrollbarWidth + 'px';

            // open
            this.isOpen = true;

            // autoHide countdown
            clearTimeout(this.countdownTimer);
            if (this.options.autoHideLength >= 0) {
                this.countdown = this.options.autoHideLength;
                this.countdownTimer = setTimeout(this.progress, 1000);
            }

            this.$on('close', () => this.hide());

            return new Deferred();
        },
        progress() {
            if (--this.countdown < 0) {
                this.$emit('close');
                this.hide();
            } else {
                this.countdownTimer = setTimeout(this.progress, 1000);
            }
        },
        hide() {
            // scrollbar handle
            document.body.classList.remove('v-dialog-show');
            document.body.style.paddingRight = '';

            this.$off();
            this.isOpen = false;

            // 執行關閉回調函數
            if (this.options.onClose && typeof this.options.onClose === 'function') {
                this.options.onClose();
            }
        },
        backdropClick() {
            if (this.backdropClose) {
                this.hide();
            } 
        }
    },
    mounted: function () {
        // check duplicate name
        if (dialogPlugin.dialogs[this.name]) {
            console.error('[dialog] duplicate dialog name');
            return;
        }

        // register
        dialogPlugin.dialogs[this.name] = this;
    },
    beforeDestroy: function () {
        // unregister
        dialogPlugin.dialogs[this.name] = undefined;
    }
};

export let _plugin;
export const dialog =  {
    // 取得指定 dialog
    // name: dialog名稱(唯一), ex: <dialogComponent name="confirm"></dialogComponent>
    get(name) {
        return _plugin.dialogs[name];
    },
    close(name) {
        let _dialog = _plugin.dialogs[name];
        if (_dialog) {
            _dialog.hide();
        }
    },
    // 通用提示 (純訊息、倒數關閉)
    // message: 顯示訊息 (可含html tag)
    // options: dialog自定義設定
    // statusCode: HTTP 狀態碼 (非必填)
    warning(message, options, statusCode) {
        // 使用方式 -----
        // let res = await this.$dialog.warning("test");
        // -- 例外處理需使用 try { } catch { } 處理
        // -- 參數 res: { dialog: Object }, 
        //      dialog: 整個dialog的資訊(含data、options...)
        
        let toastWarning = _plugin.dialogs['toastWarning'];
        if (toastWarning) {
            let finalMessage = message;
            if (statusCode !== undefined) {
                finalMessage += ` (${statusCode})`;
            }
            
            const toastData = {
                message: finalMessage,
                icon: (options && options.waringIcon) || 0 // 預設使用驚嘆號
            };
            
            // 直接返回 toast 組件的 deferred promise
            return toastWarning.add(toastData);
        }
    },
    // 通用確認提示 (純訊息、有確認及取消按鈕)
    // message: 顯示訊息 (可含html tag)
    // options: dialog自定義設定
    confirm(message, options) {
        // 使用方式 -----
        // let res = await this.$dialog.confirm("test");
        // -- 例外處理需使用 try { } catch { } 處理
        // -- 參數 res: { dialog: Object, state: Boolean }, 
        //      dialog: 整個dialog的資訊(含data、options...), state: true為點擊確認、false為點擊取消、關閉
        let dialog = _plugin.dialogs['confirm'];
        let opts = options || {};

        let deferred = dialog.show({ message: message }, opts);
        dialog.$on('confirm', () => {
            deferred.resolve({ dialog: dialog, state: true });
            dialog.hide();
        });
        dialog.$on(['cancel', 'close'], () => {
            deferred.resolve({ dialog: dialog, state: false });
            dialog.hide();
        });
        return deferred;
    },
};

export const dialogPlugin = {
    install: function (Vue, options) {
        _plugin = this;
        _plugin.dialogs = {};
        _plugin.scrollbarWidth = options.NonFixedBody ? 0 : _getScrollbarWidth();

        // global register component
        Vue.component('dialogComponent', options.dialogComponent);

        // register ToastWarningComponent if provided
        if (options.ToastDialog) {
            Vue.component('ToastDialog', options.ToastDialog);
        }

        Vue.prototype.$dialog = dialog;
        // 註冊 waringIcon 為全域屬性
        Vue.prototype.$waringIcon = dialogConstant.waringIcon;
    }
};

export class Deferred {
    constructor() {
        let resolve, reject;
        let promise = new Promise((_resolve, _reject) => {
            resolve = _resolve;
            reject = _reject;
        });

        promise.resolve = resolve;
        promise.reject = reject;
        return promise;
    }
}

function _getScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar";
    document.body.appendChild(outer);
    var widthNoScroll = outer.offsetWidth;
    outer.style.overflow = "scroll";
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    var widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
}

export default dialogPlugin; 